import React from "react";

import { useDispatch } from "react-redux";
import { Link, NavLink } from "react-router-dom";

import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";

import CallUsNow from "../common/CallUsNow";
import { clearLocalStoarge } from "../helpers/utils";
import logo from "../../assets/footer/equity black.png";
import help_center from "../../assets/icons/help_center.svg";
import { serviceProviderSignupAction } from "../../redux/slices/serviceProvider/SPSignUpSlice";

const ServiceProvidersAdminNavbar = () => {
  const dispatch = useDispatch();
  const queryString = window.location.pathname;
  console.log("url val==>>", queryString);

  return (
    <>
      <Navbar
        className={`bg-white py-3 ${
          (localStorage.getItem("preference") === null ||
            localStorage.getItem("preference").length === 0) &&
          "top_40"
        }`}
        id="adminHeader"
      >
        <Container fluid className="px-20">
          <Navbar.Brand className="signup_logo">
            <NavLink to="/for-customer">
              <img
                src={logo}
                alt="logo"
                className="logo-custom-width"
                width="250px"
                height="100%"
              />
            </NavLink>
          </Navbar.Brand>
          <Navbar.Collapse className="justify-content-end">
            <div className="supportContact d-flex align-items-center">
              {queryString !== "/login" && (
                <NavLink
                  to="/login"
                  className="text-blue text-decoration-none px-3"
                  onClick={() => {
                    dispatch(serviceProviderSignupAction.resetSPState({}));
                    clearLocalStoarge();
                  }}
                >
                  Login
                </NavLink>
              )}
              <img
                src={help_center}
                alt="help_center"
                className="me-1 d-none d-sm-block"
              />
              <span className="me-1 d-none d-sm-block">Having trouble?</span>
              <CallUsNow
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                renderText={
                  <Link className="text-blue text-decoration-none" to="">
                    Contact support
                  </Link>
                }
              />
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default ServiceProvidersAdminNavbar;
